/* .grid { */
/*   display: grid; */
/*   grid-template-columns: repeat(12, 1fr); */
/*   grid-auto-rows: minmax(80px, auto); */
/*   gap: var(--mantine-spacing-md); */
/*   width: 100%; */
/* } */
/**/
/* .cell { */
/*   min-width: 0; */
/*   min-height: 0; */
/*   overflow: hidden; */
/* } */

@property --angle {
  syntax: '<angle>';
  inherits: true;
  initial-value: 0turn;
}

@property --pos {
  syntax: '<percentage>';
  inherits: true;
  initial-value: 0%;
}

@property --color-1 {
  syntax: '<color>';
  inherits: true;
  initial-value: transparent;
}

@property --color-2 {
  syntax: '<color>';
  inherits: true;
  initial-value: transparent;
}

.grid-container {
  display: grid;
  gap: var(--mantine-spacing-xs);
  anchor-name: --grid-container;
  anchor-scope: all;
  grid-template-rows: [title] min-content;
  border-radius: var(--mantine-radius-xs);
  .tiles {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: auto;
    gap: var(--mantine-spacing-xs);
    border-radius: inherit;
  }
  &:fullscreen {
    width: 100%;
    height: 100%;
    padding: var(--mantine-spacing-lg);
    background: var(--mantine-color-dark-9);
    .tiles {
      overflow: auto;
    }
  }
}

.grid-item {
  anchor-name: --grid-item;
  anchor-scope: all;
  background: linear-gradient(
    to bottom,
    alpha(var(--mantine-color-dark-6), 0.3),
    alpha(var(--mantine-color-dark-7), 0.5)
  );
  border-radius: inherit;
  display: grid;
  :fullscreen & {
    overflow: hidden;
  }
}

.header {
  display: flex;
  gap: var(--mantine-spacing-lg);
  align-items: center;
  .button-root {
    padding: 0.2rem;
  }
}

.header-actions {
  display: flex;
  gap: var(--mantine-spacing-xs);
  align-items: center;
  margin-inline-start: auto;
}

.title {
  display: flex;
  column-gap: var(--mantine-spacing-xs);
  align-items: center;
  font-size: var(--mantine-font-size-sm);
  font-weight: var(--mantine-heading-font-weight);
  color: var(--mantine-color-dark-1);
}

.grid-item-error {
  padding: var(--mantine-spacing-md);
  color: var(--mantine-color-red-6);
}

.error-title {
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
}

.error-message {
  margin-top: var(--mantine-spacing-xs);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-gray-5);
}
